import type { ReactNode } from "react";
import "./SectionHeading.css";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  lede?: ReactNode;
  align?: "left" | "center";
  level?: 2 | 3;
}

export function SectionHeading({
  eyebrow,
  title,
  lede,
  align = "left",
  level = 2,
}: SectionHeadingProps) {
  const Heading = level === 2 ? "h2" : "h3";
  return (
    <div className={`section-heading section-heading-${align}`}>
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      <Heading className="section-heading-title">{title}</Heading>
      {lede ? <p className="section-heading-lede">{lede}</p> : null}
    </div>
  );
}
